import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

const ProtectedRoutes = () => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem('falcon_admin_token') !== null;

  useEffect(() => {
    if (!isAuthenticated) {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: 'You need to be logged in to access this page',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      });
    }
  }, [isAuthenticated]);

  // Redirect to the login/home page if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // Render the child routes
  return <Outlet />;
};

export default ProtectedRoutes;
